import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import BlogListPage from './pages/BlogListPage';
import BlogArticlePage from './pages/BlogArticlePage';
import ContactPage from './pages/ContactPage';
// import LandingLayout from './components/LandingLayout';
import Home from './pages/Home';
import ForMyClientsPage from './pages/ForMyClientsPage';
import DownloadsPage from './pages/DownloadsPage';
import EqUpLandingPage from './pages/EqUpLandingPage';
import TestLanding from './pages/TestLanding';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="/home" element={<Layout><Home /></Layout>} />
        <Route path="/downloads" element={<Layout><DownloadsPage /></Layout>} />
        <Route path="/for-my-clients" element={<Layout><ForMyClientsPage /></Layout>} />
        <Route path="/blog" element={<Layout><BlogListPage /></Layout>} />
        <Route path="/blog/:slug" element={<Layout><BlogArticlePage /></Layout>} />
        <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
        <Route path="/eq-up" element={<EqUpLandingPage />} />
        <Route path="/test" element={<TestLanding />} />
      </Routes>
    </Router>
  );
}

export default App;
